/* eslint-disable */
import createIcon from '../createIcon';

const IconUpOutlined = createIcon({
  name: 'icon-up-outlined',
  content: '<path d="M512.956 321.155h-.637l-315.42 315.42 45.879 45.88 270.178-270.816 270.178 270.815 45.242-45.879-315.42-315.42z"/>',
  width: 1024,
  height: 1024
});
export default IconUpOutlined;
